module.exports = __webpack_public_path__ + "img/message.8ef3f7e4.png";